interface CustomIconCustomerJourneyMapProps extends React.SVGProps<SVGSVGElement> {}

export function CustomIconCustomerJourneyMap({ width, height, ...props }: CustomIconCustomerJourneyMapProps) {
  return (
    <svg
      width={width || 24}
      height={height || 24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M8 8.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm4.253 11.524a.886.886 0 0 0 1.212-.004l2.286-2.196a.8.8 0 0 0 .249-.58.8.8 0 0 0-.253-.576L13.461 14.5a.886.886 0 0 0-1.212.004.793.793 0 0 0 .004 1.157l.806.764H8.4a2.551 2.551 0 0 1 0-5.101h8.113a3.337 3.337 0 0 0 0-6.675h-1.464a1.6 1.6 0 1 0-.208 1.685c.051.01.104.015.159.015h1.513a1.637 1.637 0 0 1 0 3.274H8.4a4.251 4.251 0 0 0 0 8.5h4.623l-.774.745a.792.792 0 0 0 .004 1.156ZM8 6.8a1.3 1.3 0 1 1 0-2.6 1.3 1.3 0 0 1 0 2.6Z"
      />
    </svg>
  );
}
